import type { SxProps, Theme } from '@mui/material';

/** Three-column / aside+content show layouts: stack on mobile, side-by-side from md. */
export const showPageRowSx: SxProps<Theme> = {
    mt: 2,
    mb: 2,
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    alignItems: { xs: 'stretch', md: 'flex-start' },
    gap: { xs: 2, md: 0 },
    width: '100%',
    minWidth: 0,
    px: { xs: 1, md: 0 },
    boxSizing: 'border-box',
};

/** Fixed 250px aside on desktop; full-width on mobile. */
export const showAsideSx: SxProps<Theme> = {
    ml: { xs: 0, md: 4 },
    width: { xs: '100%', md: 250 },
    minWidth: { xs: 0, md: 250 },
    flexShrink: 0,
    px: { xs: 0, md: 0 },
};

export const showMainSx: SxProps<Theme> = {
    flex: 1,
    minWidth: 0,
    width: '100%',
};
